import { Button, Icon, Link, Tooltip, Typography, palette } from "@callcenter/design-system"
import { t } from "i18next"
import { Trans } from "react-i18next"
import { useGate, useUnit } from "effector-react"

import { selfServiceModel, trialBalanceModel } from "../../models"

import styles from "./styles.module.pcss"

export const TrialBalanceLowMessage = () => {
  useGate(trialBalanceModel.BalanceTrialGate)

  const shouldShow = useUnit(trialBalanceModel.$shouldShowTrialBalanceLow)
  const isUpgradeDisabled = useUnit(selfServiceModel.$isUpgradeDisabled)
  const balance = useUnit(trialBalanceModel.$trialBalance)

  const actions = useUnit({
    upgradeNow: selfServiceModel.upgradeNowClicked,
    contactUs: selfServiceModel.contactUsClicked,
    dismiss: trialBalanceModel.balanceLowDismissed
  })

  if (!shouldShow) {
    return null
  }

  return (
    <div className={styles.wrapper} data-testid="trial-balance-low-message">
      <div className={styles.inner}>
        <div className={styles.left}>
          <Icon icon={Icon.icons.system.s.stateIndicators.warning} size={16} />
          <Typography.Body2>
            <Trans
              i18nKey="component_commonKeys_selfService_trialBalanceLow_message"
              values={{ balance: (balance ?? 0).toFixed(2) }}
              components={{ medium: <span className={styles.medium} /> }}
            />
          </Typography.Body2>
        </div>

        <div className={styles.right}>
          <Link onClick={actions.contactUs}>{t("component_commonKeys_contactUsButton_contactUsButton")}</Link>
          <Tooltip
            isVisibleDisabled={!isUpgradeDisabled}
            title={t("component_commonKeys_selfService_upgradeRequestSent_tooltipText")}
            position="aboveCenter"
          >
            <Button onClick={actions.upgradeNow} isDisabled={isUpgradeDisabled}>
              {t("component_commonKeys_trialExpired_upgradeButton")}
            </Button>
          </Tooltip>
          <button
            type="button"
            className={styles.closeButton}
            onClick={() => actions.dismiss()}
            aria-label={t("component_commonKeys_closeButton_closeButtonLabel")}
            data-testid="trial-balance-low-message-dismiss"
          >
            <Icon icon={Icon.icons.system.s.utilities.cross} size={16} color={palette.gray7} />
          </button>
        </div>
      </div>
    </div>
  )
}
